import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Doctors_List = () => {
    const [doctorList, setDoctorList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        const fetchDoctorsList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getDoctors`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setDoctorList(data.data);
                    setFilteredData(data.data);
                } else {
                    console.error('Data is not an array:', data);
                    setDoctorList([]);
                    setFilteredData([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchDoctorsList();
    }, []);

    // Search Functionality
    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredData(doctorList);
        } else {
            const filtered = doctorList.filter(item =>
                item.comp_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.emp_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.pay_model?.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredData(filtered);
        }
        setCurrentPage(1);
    }, [searchQuery, doctorList]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const goToPage = (pageNumber) => setCurrentPage(pageNumber);

    const exportToExcel = () => {
        const exportData = filteredData.map((doctor, index) => ({
            SNo: index + 1,
            Name: doctor.comp_name,
            BMID: doctor.emp_code,
            DOJ: doctor.doj,
            Mobile: doctor.mobile,
            Email: doctor.email,
            Type: doctor.pay_model,
            Status: doctor.active === "1" ? "Active" : "Inactive",
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Doctors");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

        saveAs(dataBlob, "Doctors_List.xlsx");
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                    <div className="header-title col-4">
                                        <h4 className="card-title">Doctors List</h4>
                                    </div>
                                    <div className="header-action col-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group mb-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search by Name, BMID, Email, Role, or Mobile"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end gap-2">
                                                <Link to="/add_doctor" className="btn btn-sm btn-primary">Add Doctor</Link>
                                                <button className="btn btn-sm btn-success" onClick={exportToExcel}>Export to Excel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="col-12 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">BMID</th>
                                        <th scope="col">DOJ</th>
                                        <th scope="col">Mobile</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRecords.length > 0 ? (
                                        currentRecords.map((doctor, index) => (
                                            <tr key={doctor.doc_id}>
                                                <th scope="row">{indexOfFirstRecord + index + 1}</th>
                                                <td>{doctor.comp_name}</td>
                                                <td>{doctor.emp_code}</td>
                                                <td>{doctor.doj}</td>
                                                <td>{doctor.mobile}</td>
                                                <td>{doctor.email}</td>
                                                <td>{doctor.pay_model}</td>
                                                <td>{doctor.active}</td>
                                                <td>
                                                    <Link to={`/edit_doctor/${doctor.doc_id}`} className="btn btn-sm btn-primary">Edit</Link>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">No records found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-center align-items-center mt-3">
                            <nav>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            «
                                        </button>
                                    </li>

                                    {totalPages > 5 && currentPage > 3 && (
                                        <li className="page-item">
                                            <button className="page-link" onClick={() => goToPage(1)}>1</button>
                                        </li>
                                    )}
                                    {totalPages > 5 && currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}

                                    {Array.from({ length: totalPages }, (_, index) => index + 1)
                                        .filter(pageNumber =>
                                            pageNumber === 1 ||
                                            pageNumber === totalPages ||
                                            (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                                        )
                                        .map(pageNumber => (
                                            <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                                                <button className="page-link" onClick={() => goToPage(pageNumber)}>{pageNumber}</button>
                                            </li>
                                        ))
                                    }

                                    {totalPages > 5 && currentPage < totalPages - 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                                    {totalPages > 5 && currentPage < totalPages - 2 && <li className="page-item"><button className="page-link" onClick={() => goToPage(totalPages)}>{totalPages}</button></li>}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                            »
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Doctors_List;
